"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetAnonymousId = void 0;
const uuid_1 = require("uuid");
const visitorCookie_1 = require("./visitorCookie");
const analytics_1 = require("../../analytics");
/**
 * Checks for the visitor ID cookie, and if it doesn't exist,
 * it sets the cookie and returns the value.
 */
const getVisitorId = () => {
    const visitorId = (0, visitorCookie_1.getVisitorIdCookie)() || (0, uuid_1.v4)();
    (0, visitorCookie_1.setVisitorIdCookie)(visitorId);
    return visitorId;
};
const resetAnonymousId = (hasUserRejectedAllCategories) => {
    const visitorId = getVisitorId();
    if (hasUserRejectedAllCategories) {
        (0, analytics_1.setAnonymousId)(visitorId);
        return;
    }
    const anonymousId = (0, analytics_1.getAnonymousId)();
    // To avoid overwriting the anonymous ID repeatedly after it has already changed
    if (anonymousId !== visitorId) {
        return;
    }
    (0, analytics_1.setAnonymousId)((0, uuid_1.v4)());
};
exports.resetAnonymousId = resetAnonymousId;
//# sourceMappingURL=visitorId.js.map